import { isNil } from 'lodash-es'
import LogicFlow from '@logicflow/core'

type ControlItem = {
  key: string
  iconClass: string
  title: string
  text: string
  hideText?: boolean
  onClick?: (lf: LogicFlow, e: MouseEvent) => void
  onMouseEnter?: (lf: LogicFlow, e: MouseEvent) => void
  onMouseLeave?: (lf: LogicFlow, e: MouseEvent) => void
}

export class Control {
  static pluginName = 'control'

  private readonly lf: LogicFlow
  private controlItems: ControlItem[] = [
    {
      key: 'zoom-out',
      iconClass: 'lf-control-zoomOut',
      title: '缩小流程图',
      text: '缩小',
      hideText: false,
      onClick: () => {
        this.lf.zoom(false)
      },
    },
    {
      key: 'zoom-in',
      iconClass: 'lf-control-zoomIn',
      title: '放大流程图',
      text: '放大',
      hideText: false,
      onClick: () => {
        this.lf.zoom(true)
      },
    },
    {
      key: 'reset',
      iconClass: 'lf-control-fit',
      title: '恢复流程原有尺寸',
      text: '适应',
      hideText: false,
      onClick: () => {
        this.lf.resetZoom()
      },
    },
    {
      key: 'undo',
      iconClass: 'lf-control-undo',
      title: '回到上一步',
      text: '上一步',
      hideText: false,
      onClick: () => {
        this.lf.undo()
      },
    },
    {
      key: 'redo',
      iconClass: 'lf-control-redo',
      title: '移到下一步',
      text: '下一步',
      hideText: false,
      onClick: () => {
        this.lf.redo()
      },
    },
  ]
  private domContainer?: HTMLElement
  private toolEl?: HTMLElement

  constructor({ lf }: LogicFlow.IExtensionProps) {
    this.lf = lf
  }

  render(_: LogicFlow, domContainer: HTMLElement) {
    this.destroy()
    const toolEl = this.getControlTool()
    this.toolEl = toolEl
    domContainer.appendChild(toolEl)
    this.domContainer = domContainer
  }

  destroy() {
    if (
      this.domContainer &&
      this.toolEl &&
      this.domContainer.contains(this.toolEl)
    ) {
      this.domContainer.removeChild(this.toolEl)
    }
  }

  addItem(item: ControlItem) {
    this.controlItems.push(item)
  }

  removeItem(key: string) {
    const index = this.controlItems.findIndex((item) => item.key === key)
    return index == -1 ? null : this.controlItems.splice(index, 1)[0]
  }

  private getControlTool(): HTMLElement {
    const { themeMode } = this.lf.graphModel
    const NORMAL = `lf-control-item-${themeMode} lf-control-item`
    const DISABLED = 'lf-control-item disabled'
    const controlTool = document.createElement('div')
    const controlElements: HTMLDivElement[] = []
    controlTool.className = `lf-control-${themeMode} lf-control`

    const itemsToRender = [...this.controlItems]
    itemsToRender.forEach((item) => {
      const itemContainer = document.createElement('div')
      const icon = document.createElement('i')
      itemContainer.className = DISABLED
      item.onClick && (itemContainer.onclick = item.onClick.bind(null, this.lf))
      item.onMouseEnter &&
        (itemContainer.onmouseenter = item.onMouseEnter.bind(null, this.lf))
      item.onMouseLeave &&
        (itemContainer.onmouseleave = item.onMouseLeave.bind(null, this.lf))
      icon.className = item.iconClass
      if (isNil(item.hideText) || item.hideText !== true) {
        const text = document.createElement('span')
        text.className = `lf-control-text-${themeMode} lf-control-text`
        text.title = item.title
        text.innerText = item.text
        itemContainer.append(icon, text)
      } else {
        itemContainer.append(icon)
      }
      switch (item.key) {
        case 'undo':
          this.lf.on('history:change', ({ data: { undoAble } }: any) => {
            itemContainer.className = undoAble ? NORMAL : DISABLED
          })
          break
        case 'redo':
          this.lf.on('history:change', ({ data: { redoAble } }: any) => {
            itemContainer.className = redoAble ? NORMAL : DISABLED
          })
          break
        default:
          itemContainer.className = NORMAL
          break
      }
      controlElements.push(itemContainer)
    })
    controlTool.append(...controlElements)
    return controlTool
  }
}

export default Control
